:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

:root {
  --indent: var(--spacing-comp-02);
}

gxg-grid {
  display: contents;
}

ch-grid {
  border: 1px solid var(--gray-02);
  --focus-style: 2px solid var(--color-primary-active);
}

ch-grid::part(main) {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
ch-grid::part(main)::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
ch-grid::part(main)::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
ch-grid::part(main)::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
ch-grid::part(main)::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

gxg-grid.no-border ch-grid {
  border: 0;
}

gxg-grid:focus-visible,
ch-grid:focus-visible {
  outline: none;
}

ch-grid::part(header),
ch-grid::part(footer) {
  /*padding: var(--spacing-comp-01);*/
  background-color: var(--color-background);
}

ch-grid-actionbar ch-grid-action-refresh,
ch-grid-actionbar ch-grid-action-settings,
ch-grid-column::part(bar-sort-ascending),
ch-grid-column::part(bar-sort-descending),
ch-grid-column::part(bar-settings-button),
ch-grid-column::part(settings-close),
ch-grid::part(settings-close),
ch-grid-cell::part(drag-icon),
ch-grid-cell::part(caret),
ch-grid-rowset-legend::part(caret) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
ch-grid-actionbar ch-grid-action-refresh:before,
ch-grid-actionbar ch-grid-action-settings:before,
ch-grid-column::part(bar-sort-ascending):before,
ch-grid-column::part(bar-sort-descending):before,
ch-grid-column::part(bar-settings-button):before,
ch-grid-column::part(settings-close):before,
ch-grid::part(settings-close):before,
ch-grid-cell::part(drag-icon):before,
ch-grid-cell::part(caret):before,
ch-grid-rowset-legend::part(caret):before {
  content: "";
  display: block;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  -webkit-mask-position: center;
  width: 70%;
  height: 70%;
  background-color: var(--color-on-secondary);
}

ch-grid-action-refresh,
ch-grid-action-settings {
  width: var(--spacing-comp-05);
  height: var(--spacing-comp-05);
  cursor: pointer;
  background-color: var(--color-secondary-enabled);
  display: inline-block;
}
ch-grid-action-refresh:hover,
ch-grid-action-settings:hover {
  background-color: var(--color-secondary-hover);
}
ch-grid-action-refresh:focus-visible,
ch-grid-action-settings:focus-visible {
  outline: var(--focus-style);
}

ch-grid-action-refresh:before {
  -webkit-mask-image: var(--refreshIconUrl);
}

ch-grid-action-settings:before {
  -webkit-mask-image: var(--settingshIconUrl);
}

ch-grid {
  font-family: var(--font-family-primary);
  font-size: var(--font-size-sm);
  color: var(--gray-06);
}

ch-grid-column {
  background-color: var(--color-background);
  font-weight: var(--font-weight-bold);
  padding: var(--spacing-comp-02) !important;
  cursor: pointer;
}

ch-grid-column::part(bar) {
  gap: var(--spacing-comp-02);
  width: 100%;
}

ch-grid-column:not([sort-direction])::part(bar-sort) {
  display: none;
}

ch-grid-column::part(bar-settings) {
  line-height: 0;
}

ch-grid-column::part(bar-sort-ascending),
ch-grid-column::part(bar-sort-descending) {
  width: var(--spacing-comp-03);
  height: var(--spacing-comp-03);
  margin-left: var(--spacing-comp-02);
  margin-right: var(--spacing-comp-01);
}

ch-grid-column::part(bar-sort-ascending):before,
ch-grid-column::part(bar-sort-descending):before {
  width: 100%;
  height: 100%;
  -webkit-mask-size: 200%;
}

ch-grid-column::part(bar-sort-descending):before {
  -webkit-mask-image: var(--barSortDescendingIconUrl);
}

ch-grid-column::part(bar-sort-ascending):before {
  -webkit-mask-image: var(--barSortAscendingIconUrl);
}

ch-grid-column::part(bar-resize-split) {
  width: 3px;
  background-color: var(--gray-02);
}

ch-grid-column:last-child::part(bar-resize-split) {
  display: none;
}

ch-grid-column::part(bar-settings-button) {
  padding: 0;
  width: var(--spacing-comp-05);
  height: var(--spacing-comp-05);
  border: none;
  background-color: transparent;
  cursor: pointer;
}
ch-grid-column::part(bar-settings-button):hover {
  background-color: var(--gray-02);
}
ch-grid-column::part(bar-settings-button):focus-visible {
  outline: var(--focus-style);
}

ch-grid-column::part(bar-settings-button):before {
  -webkit-mask-image: var(--barSettingsButtonIconUrl);
}

ch-grid-row {
  background-color: var(--color-background);
  color: var(--gray-04);
  border: 2px solid transparent;
}
ch-grid-row ch-grid-cell {
  border-top-width: 1px;
}
ch-grid-row:nth-of-type(odd) {
  background-color: var(--gray-00);
}

ch-grid-row[highlighted] {
  background-color: var(--gxg-background-color--hover);
}

ch-grid-row[dragging] {
  box-shadow: var(--box-shadow-03);
}

ch-grid-row[selected] > ch-grid-cell:not([selected]) {
  background-color: var(--gxg-background-color--selected);
}

ch-grid-cell[selected] {
  z-index: 1;
  background-color: var(--gxg-background-color--selected) !important;
}

ch-grid-row[selected] > ch-grid-cell {
  color: var(--color-on-secondary);
}
ch-grid-row[selected] + ch-grid-row[selected] ch-grid-cell {
  border-top-color: var(--gxg-border-color--selected);
}
ch-grid-row[selected]:hover > ch-grid-cell {
  background-color: var(--gxg-background-color--selected-hover) !important;
}

ch-grid-cell {
  box-sizing: border-box;
  padding-inline-start: var(--spacing-comp-02) !important;
  padding-inline-end: var(--spacing-comp-02) !important;
  padding-block-start: var(--spacing-comp-01);
  padding-block-end: var(--spacing-comp-01);
  align-items: center;
  font-size: var(--font-size-md);
  line-height: var(--line-height-regular);
}

ch-grid-column::part(settings-mask) {
  cursor: default;
}

ch-grid-column::part(settings-mask),
ch-grid::part(settings-mask) {
  background-color: rgba(0, 0, 0, 0.3);
  cursor: arrow;
  color: var(--color-on-secondary);
}

ch-grid-column::part(settings-window),
ch-grid::part(settings-window) {
  background-color: var(--color-background);
  width: 100%;
  max-width: 600px;
  padding: var(--spacing-comp-03);
  border-radius: var(--border-width-lg);
  box-shadow: var(--box-shadow-04);
}

ch-grid::part(settings-window) {
  margin: 0 var(--spacing-comp-05);
}

ch-grid-column::part(settings-header),
ch-grid::part(settings-header) {
  display: flex;
  align-items: center;
  gap: var(--spacing-comp-04);
  justify-content: space-between;
  border-bottom: var(--border-width-sm) solid var(--gray-02);
  padding-bottom: var(--spacing-comp-02);
  margin-bottom: var(--spacing-comp-03);
  font-weight: var(--font-weight-bold);
}

ch-grid-column::part(settings-close),
ch-grid::part(settings-close) {
  padding: 0;
  width: var(--spacing-comp-05);
  height: var(--spacing-comp-05);
  cursor: pointer;
  background-color: var(--color-secondary-enabled);
  font-size: 0;
  border: 0;
}
ch-grid-column::part(settings-close):hover,
ch-grid::part(settings-close):hover {
  background-color: var(--color-secondary-hover);
}
ch-grid-column::part(settings-close):before,
ch-grid::part(settings-close):before {
  -webkit-mask-image: var(--settingsCloseIconUrl);
}
ch-grid-column::part(settings-close):focus-visible,
ch-grid::part(settings-close):focus-visible {
  outline: var(--focus-style);
}

ch-grid::part(settings-columns) {
  gap: var(--spacing-comp-03);
}

ch-grid::part(settings-columns-label) {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-comp-03);
  cursor: pointer;
  height: var(--spacing-comp-04);
}

/*Checkboxes*/
ch-grid::part(settings-columns-visible),
ch-grid-cell::part(selector),
ch-grid-column::part(selector) {
  position: relative;
  margin: 0;
  height: var(--spacing-comp-04);
  width: var(--spacing-comp-04);
}
ch-grid::part(settings-columns-visible):focus-visible,
ch-grid-cell::part(selector):focus-visible,
ch-grid-column::part(selector):focus-visible {
  outline: var(--focus-style);
}

ch-grid::part(settings-columns-visible):before,
ch-grid-cell::part(selector):before,
ch-grid-column::part(selector):before {
  cursor: pointer;
  content: "";
  display: inline-block;
  position: relative;
  height: var(--spacing-comp-04);
  width: var(--spacing-comp-04);
  border-width: var(--border-width-sm);
  border-style: var(--border-style-regular);
  border-radius: var(--border-radius-md);
  border-color: var(--gray-04);
  box-sizing: border-box;
  flex-shrink: 0;
  background: var(--color-background);
}

ch-grid::part(settings-columns-visible):after,
ch-grid-cell::part(selector):after,
ch-grid-column::part(selector):after {
  opacity: 0;
  display: block;
  position: absolute;
  content: "";
  left: 6px;
  top: 3px;
  width: 3px;
  height: 7px;
  border: solid;
  border-color: var(--color-primary-hover);
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  transition-property: opacity;
  transition-duration: var(--ui-animaton-speed);
  transition-timing-function: ease;
  cursor: pointer;
}

ch-grid-column::part(indeterminate):after {
  opacity: 1;
  display: block;
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
  width: 8px;
  height: 1.5px;
  border: 0;
  background-color: var(--color-primary-hover);
  -webkit-transform: rotate(0) translateY(-50%) translateX(-50%);
  -ms-transform: rotate(0) translateY(-50%) translateX(-50%);
  transform: rotate(0) translateY(-50%) translateX(-50%);
}

ch-grid::part(settings-columns-visible-checked):before,
ch-grid-cell::part(checked):before,
ch-grid-column::part(checked):before {
  border-color: var(--color-primary-hover);
}

ch-grid::part(settings-columns-visible-checked):after,
ch-grid-cell::part(checked):after,
ch-grid-column::part(checked):after {
  opacity: 1;
}

/*Drag*/
ch-grid-cell::part(drag-icon):before {
  width: var(--spacing-comp-04);
  height: var(--spacing-comp-04);
  cursor: grab;
}

ch-grid-cell::part(drag-icon):before {
  -webkit-mask-image: var(--dragIconUrl);
}

/*Row actions*/
ch-grid::part(row-actions) {
  padding-top: 2px;
  right: var(--spacing-comp-02);
}

/*Selector*/
/*legend*/
ch-grid-rowset-legend {
  background-color: var(--gray-01);
  padding-inline-start: var(--spacing-comp-02);
  padding-inline-end: var(--spacing-comp-02);
  padding-block-start: var(--spacing-comp-01);
  padding-block-end: var(--spacing-comp-01);
}

/*columnset*/
ch-grid > ch-grid-rowset:first-of-type ch-grid-rowset-legend {
  border-top: 1px solid var(--color-background);
}

ch-grid-rowset-legend {
  margin-inline-start: calc(var(--indent) * (var(--level) - 1));
  display: flex;
  align-items: center;
  gap: var(--spacing-comp-01);
  cursor: pointer;
}

/*caret*/
ch-grid-rowset-legend::part(caret),
ch-grid-cell::part(caret) {
  width: var(--spacing-comp-04);
  height: var(--spacing-comp-04);
}

ch-grid-cell::part(caret) {
  cursor: pointer;
  margin-right: var(--spacing-comp-01);
}

ch-grid-rowset > ch-grid-rowset-legend::part(caret):before,
ch-grid-row > ch-grid-cell::part(caret):before {
  -webkit-mask-image: var(--caretCollapseIconUrl);
}

ch-grid-rowset[collapsed] > ch-grid-rowset-legend::part(caret):before,
ch-grid-row[collapsed] > ch-grid-cell::part(caret):before {
  -webkit-mask-image: var(--caretExpandIconUrl);
}

ch-grid-rowset[collapsed] ch-grid-rowset-legend {
  border-bottom: 1px solid var(--color-background);
}

/*paginator*/
ch-grid gxg-paginator {
  padding-top: 0;
  padding-bottom: 0;
}

/*Full-height*/
gxg-grid[full-height] {
  height: 100%;
}
gxg-grid[full-height] ch-grid {
  height: 100%;
}

/*ellipsis*/
gxg-grid[ellipsis] ch-grid-cell {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

/*ellipsis-cell-wrapper*/
gxg-grid[ellipsis-cell-wrapper] .cell-wrapper {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: inherit;
}

gxg-grid[ellipsis-cell-wrapper] ch-grid-column::part(bar-resize-split) {
  display: none;
}

/*********************************************
LARGE VERSION (html tag has 'gxg-large' class)
**********************************************/
gxg-grid.large ch-grid {
  font-size: var(--font-size-lg);
}